import { create } from "zustand";

export const useGlobalSearchStore = create<GlobalSearchState>((set) => ({
    searchQuery: '',
    setSearchQuery: (searchQuery: any) => set({ searchQuery }),
    wasPaneOpened: false,
    setWasPaneOpened: (wasPaneOpened: any) => set({ wasPaneOpened }),
    searchResultItemSelected: false,
    setSearchResultItemSelected: (searchResultItemSelected: any) => set({ searchResultItemSelected }),
    resultItemSelectedFromResultPage: false,
    setResultItemSelectedFromResultPage: (resultItemSelectedFromResultPage: any) => set({ resultItemSelectedFromResultPage }),
    previousRoute: '',
    setPreviousRoute: (previousRoute: any) => set({ previousRoute }),
}));

export interface GlobalSearchState {
    searchQuery: string;
    setSearchQuery: (searchQuery:string) => void;
    wasPaneOpened: boolean;
    setWasPaneOpened: (wasPaneOpened:boolean) => void;
    searchResultItemSelected: boolean;
    setSearchResultItemSelected: (searchResultItemSelected:boolean) => void;
    resultItemSelectedFromResultPage: boolean;
    setResultItemSelectedFromResultPage: (resultItemSelectedFromResultPage:boolean) => void;
    previousRoute: string;
    setPreviousRoute: (previousRoute:string) => void;
}